<template>
  <div class="row align-items-center">
    <div class="col">
      <date-picker
        v-model="start"
        :format="format"
        :type="type"
        :transfer="true"
        :clearable="clearable"
        @on-change="$emit('change')"
      />
    </div>
    <div class="col-separator"></div>
    <div class="col">
      <date-picker
        v-model="end"
        :format="format"
        :type="type"
        :transfer="true"
        :options="disabledDate"
        :clearable="clearable"
        @on-change="sliceDate(), $emit('change')"
      />
    </div>
  </div>
</template>

<script>
  import moment from 'moment-es6';

  export default {
    props: {
      value: {
        type: [Object],
        default: () => ({})
      },

      clearable: {
        type: Boolean,
        default: true
      },

      format: {
        type: String,
        default: 'yyyy-MM-dd HH:mm:ss'
      },

      out_format: {
        type: [String, null],
        default: 'YYYY-MM-DD HH:mm:ss'
      },

      type: {
        type: String,
        default: 'datetime'
      },
      options: {
        type: Number,
        default: null
      }
    },

    data: () => ({
      start: null,
      end: null
    }),

    computed: {
      disabledDate () {
        let start = Date.parse(this.start)
        let time = this.options
        if(this.options) {
          return {
            disabledDate (date) {
              return date && date.valueOf() > start + time;
            }
          }
        }
        return {}
      }
    },

    watch: {
      value: {
        handler: function() {
          if (this.value && this.value.start !== this.start) {
            this.start = this.value.start;
          }

          if (this.value && this.value.end !== this.end) {
            this.end = this.value.end;
          }
        },
        deep: true,
        immediate: true
      },
      start: {
        handler: function() {
          this.emit();
        },
        immediate: true
      },

      end: {
        handler: function() {
          this.emit();
        },
        immediate: true
      }
    },

    methods: {
      // TODO разобраться как заблокировать часть строки
      sliceDate() {
        if(this.options) {
          this.end = this.end.slice(0,-5) + "59:59";
        }
      },
      emit: function() {

        let data = {
          start: null,
          end: null
        };

        if (moment(this.start).isValid()) {
          data.start = this.out_format ? moment(this.start).format(this.out_format) : this.start;
          this.start = data.start;
        }

        if (moment(this.end).isValid()) {
          data.end = this.out_format ? moment(this.end).format(this.out_format) : this.end;
          this.end = data.end;
        }

        this.$emit('input', data);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .col-separator {
    flex: none;
    background: #e8eaec;
    height: 1px;
    width: 12px;
  }
</style>
